import {
    FETCH_PENDING_COMMISSIONS_REQUEST,
    FETCH_PENDING_COMMISSIONS_SUCCESS,
    FETCH_PENDING_COMMISSIONS_FAILURE,
} from "./types";

import {
    fetchPendingCommissions,
} from "../../services/pendingCommissionService";

export const fetchPendingCommissionsRequest =
    () => ({
        type: FETCH_PENDING_COMMISSIONS_REQUEST,
    });

export const fetchPendingCommissionsSuccess = (
    payload
) => ({
    type: FETCH_PENDING_COMMISSIONS_SUCCESS,
    payload,
});

export const fetchPendingCommissionsFailure = (
    error
) => ({
    type: FETCH_PENDING_COMMISSIONS_FAILURE,
    payload: error,
});

export const fetchPendingCommissionsAction =
    (
        page = 1,
        size = 10
    ) =>
    async (dispatch) => {
        dispatch(
            fetchPendingCommissionsRequest()
        );

        try {
            const response =
                await fetchPendingCommissions(
                    page,
                    size
                );

            if (response.success) {
                dispatch(
                    fetchPendingCommissionsSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };
            }

            dispatch(
                fetchPendingCommissionsFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };
        } catch (error) {
            const errMsg =
                error.message ||
                "Failed to fetch pending commissions";

            dispatch(
                fetchPendingCommissionsFailure(
                    errMsg
                )
            );

            return {
                success: false,
                error: errMsg,
            };
        }
    };